import React from 'react'
import PropTypes from "prop-types"
import {
  ClickAwayListener,
  Grid,
  TextField,
  Tooltip,
  Typography
} from "@material-ui/core";
import { Info } from "@material-ui/icons";
import { CHILE, VENDOR_FORM_SECTION_NAME, TOOLTIP_VENDOR_FORM_TITLE } from "../../../../constants"
import { VendorFormJss } from './styleJss'
import CountryDocNumberFormatter from "../../../../utils/formatter/CountryDocNumberFormatter";
import TelephoneFormatter from "../../../../utils/formatter/TelephoneFormatter";
import NameFormatter from '../../../../utils/formatter/NameFormatter';
import EmailFormatter from '../../../../utils/formatter/EmailFormatter';


const VendorForm = ({stateProps}) => {
  const classes = VendorFormJss()

 const formatters={
    'document_number': CountryDocNumberFormatter.format(stateProps.state.country),
    'email': EmailFormatter.format,
    'lastname': NameFormatter.format,
    'name': NameFormatter.format,
    'phone': (value)=>TelephoneFormatter.format(stateProps.state.country, value.toString()),
    'repeat_email': EmailFormatter.format,
  }

  const handleInputChangeWithFormat = (fieldName) => (event) => {
    const formatter=formatters[fieldName]
    const newValue=formatter(event.target.value)
    stateProps.handleSetState(fieldName, VENDOR_FORM_SECTION_NAME)(newValue)
  };

  const handleClickAway = (fieldName) => (event) => {
    if (stateProps.state[fieldName] === '') {
      stateProps.onRestoreErrors(VENDOR_FORM_SECTION_NAME, fieldName);
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
  };

  return (
    <Grid
      container
      item
      direction="row"
      className={classes.buttonGrid}
    >
      <Grid container item className={classes.formGridTitleTooltip}>
        <Tooltip 
          arrow
          className=''
          title={
            <Typography variant='h4'>
              {TOOLTIP_VENDOR_FORM_TITLE}
            </Typography>
          }
          placement="left"
        >
          <Info style={{ color: '#5b73ba' }}/>
        </Tooltip>
        Datos de usuario
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("name")}>
          <TextField className={classes.textFieldInput}
            id="name-required"
            label="Nombre"
            variant="outlined"
            size="small"
            value={stateProps.state.name}
            onChange={handleInputChangeWithFormat("name")}
            error={stateProps.errors.name !== ""}
            helperText={stateProps.errors.name}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("lastname")}>
          <TextField className={classes.textFieldInput}
            id="lastname-required"
            label="Apellido"
            variant="outlined"
            size="small"
            value={stateProps.state.lastname}
            onChange={handleInputChangeWithFormat("lastname")}
            error={stateProps.errors.lastname !== ""}
            helperText={stateProps.errors.lastname}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway('document_number')}>
          <TextField className={classes.textFieldInput}
            required
            id="document_number-required"
            label={stateProps.state.country === CHILE.value ? "RUT" : "DNI o CE"}
            variant="outlined"
            size="small"
            value={stateProps.state.document_number}
            onChange={ e => {
              e.target.value = (e.target.value).toString().slice(0,12)
              handleInputChangeWithFormat("document_number")(e)
            }}
            error={stateProps.errors.document_number !== ""}
            helperText={stateProps.errors.document_number}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("phone")}>
          <TextField className={classes.textFieldInput}
            id="phone-required"
            label={stateProps.state.country === CHILE.value ? "Teléfono (+56XXXXXXXXXX)" : "Número celular"}
            variant="outlined"
            size="small"
            value={stateProps.state.phone}
            onChange={handleInputChangeWithFormat("phone")}
            error={stateProps.errors.phone !== ""}
            helperText={stateProps.errors.phone}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway("email")}>
          <TextField className={classes.textFieldInput}
            required
            id="email-required"
            label="Correo electrónico"
            variant="outlined"
            size="small"
            value={stateProps.state.email}
            onChange={handleInputChangeWithFormat("email")}
            error={stateProps.errors.email !== ""}
            helperText={stateProps.errors.email}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
      <Grid item xs={12} md={6} className={classes.formGrid}>
        <ClickAwayListener onClickAway={handleClickAway('repeat_email')}>
          <TextField className={classes.textFieldInput}
            required
            id="repeat_email-required"
            label="Repetir correo electrónico"
            variant="outlined"
            size="small"
            onPaste={handlePaste}
            value={stateProps.state.repeat_email}
            onChange={handleInputChangeWithFormat('repeat_email')}
            error={stateProps.errors.repeat_email !== ''}
            helperText={stateProps.errors.repeat_email}
            fullWidth
          />
        </ClickAwayListener>
      </Grid>
    </Grid>
  )
}

export default VendorForm

VendorForm.propTypes = {
  stateProps: PropTypes.exact({
    state: PropTypes.exact({
      name: PropTypes.string.isRequired,
      lastname: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      repeat_email: PropTypes.string.isRequired,
      document_number: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
    }),
    setState: PropTypes.func.isRequired,
    handleSetState: PropTypes.func.isRequired,
    errors: PropTypes.exact({
      name: PropTypes.string,
      lastname: PropTypes.string,
      phone: PropTypes.string,
      email: PropTypes.string,
      repeat_email: PropTypes.string,
      document_number: PropTypes.string,
    }),
    onRestoreErrors: PropTypes.func,
  }).isRequired,
};
